import { useCallback } from 'react';
import * as pas from 'js/hooks/auth/pas';
import { useDispatch } from 'react-redux';
import { prop } from 'ramda';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { LAYER } from 'js/components/common/PopupManager';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';
import { useClosingSync } from 'js/components/system/App/hooks/usePushNotifier/hooks';
import { handleBonusNotificationInfo } from 'js/components/system/App/hooks/usePushNotifier/common/handleBonusNotificationInfo';
import { showFreeSpin2BonusPopupAction } from 'js/components/popups/FreeSpin2BonusPopup';

import { WAITING_MESSAGE_DISABLE_ALL } from './constants';
import { useGetWelcomeWaitingMessageTypes } from './useGetWelcomeWaitingMessageTypes';

export const useGetWaitingMessages = () => {
    const dispatch = useDispatch();
    const syncClose = useClosingSync();
    const lang = useUserSelector(prop('lang'));
    const getWelcomeWaitingMessageTypes = useGetWelcomeWaitingMessageTypes();
    const useDirectPASRequests = useAppSelector(prop('useDirectPASRequests'));

    return useCallback((data) => {
        const messageTypes = getWelcomeWaitingMessageTypes(data);

        if (messageTypes === WAITING_MESSAGE_DISABLE_ALL || messageTypes === '') {
            return;
        }

        (async () => {
            let response;

            try {
                response = useDirectPASRequests
                    ? await pas.getWaitingMessagesDirect({ messageTypes })
                    : await pas.getWaitingMessages({ messageTypes });
            } catch {
                return;
            }

            const {
                PlayerActionShowMessage = [],
                PlayerActionShowLoginMessage = [],
                PlayerActionShowDialog = [],
                PlayerActionShowDialog2 = []
            } = response?.data?.actions || {};

            PlayerActionShowLoginMessage
                .filter(playerMessage => Boolean(playerMessage.message))
                .forEach(playerMessage => {
                    dispatch(showCommonPopupAction({
                        title: 'playtech.mobile.system.welcomeTitle',
                        layer: LAYER.LOGIN_MESSAGES,
                        className: 'welcome-popup',
                        content: playerMessage.message
                    }));
                });

            PlayerActionShowMessage
                .filter(playerMessage => Boolean(playerMessage.message))
                .forEach(playerMessage => {
                    dispatch(showCommonPopupAction({
                        layer: LAYER.LOGIN_MESSAGES,
                        content: playerMessage.message,
                        className: 'waiting-message-push-popup',
                        title: 'playtech.mobile.system.message.congratulations'
                    }));
                });

            PlayerActionShowDialog
                .filter(playerMessage => Boolean(playerMessage.message))
                .forEach(playerMessage => {
                    const { dialogId, dialogType, message, parameters: { templateId, showGamesList } = {} } = playerMessage;
                    switch (dialogType) {
                        case 'bonusConfirmation': {
                            const actionInfo = {
                                dialogId,
                                templateId,
                                showGamesList,
                                message,
                                layer: LAYER.LOGIN_MESSAGES
                            };

                            handleBonusNotificationInfo({ actionInfo, isConfirmation: true }, { lang, syncClose, dispatch })
                                .then(action => dispatch(action))
                                .catch(error => console.error('could not dispatch action', error));

                            break;
                        }

                        default:
                            break;
                    }
                });

            PlayerActionShowDialog2
                .forEach((action) => {
                    const { message, dialogId, showGamesList, betConfigurations, gameCodeNames } = action;

                    dispatch(showFreeSpin2BonusPopupAction({
                        id: dialogId,
                        layer: LAYER.LOGIN_MESSAGES,
                        message,
                        betConfigurations,
                        gameCodeNames,
                        showGamesList,
                        dialogId,
                        onClose: () => syncClose(dialogId)
                    }));
                });
        })();

    }, [dispatch, lang, getWelcomeWaitingMessageTypes, syncClose, useDirectPASRequests]);
};
